import { useEffect } from "react";

export const useTokenCheck = ({
    isSuccessTokenCheck,
    isErrorTokenCheck,

    navigate,

    getMyPanelsMutation,
    getSystemProceduresMutation,
    getOngoingPlanListForTodayMutation,
    getGeneralOngoingPlanListMutation,
    getEmergencyStopDataListMutation,

    setBlockUI,

    i18n    
}: any) => {

    useEffect(() => {
        if (isSuccessTokenCheck) {
            setBlockUI(false);
            getOngoingPlanListForTodayMutation()
            getGeneralOngoingPlanListMutation()
            getEmergencyStopDataListMutation()
        }
    }, [isSuccessTokenCheck]);

    useEffect(() => {
        if (isErrorTokenCheck) {
            setBlockUI(false);
            navigate({ pathname: "/" });
        }
    }, [isErrorTokenCheck]);

    useEffect(() => {
        if (isSuccessTokenCheck) {
            getSystemProceduresMutation()
            getMyPanelsMutation()
        }
    }, [isSuccessTokenCheck, i18n.language])


}